import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../../boot";

// Get products
export const getPrintingList = createAsyncThunk("/get-Printing-list", async (data, { rejectWithValue }) => {
  // const token = localStorage.getItem("authToken");

  try {
    const response = await axios.post(`${baseUrl}printing/api/v1/searchPrinting`, data, {
      headers: {
        "Content-Type": "application/json",
      }
    });
    console.log("API Response:", response);
    return response.data; 
  } catch (error) {
    console.error("Error fetching Printing  List", error);
    return rejectWithValue(error.response?.data?.message || "Failed to fetch Printing  List");
  }
});